// eslint-disable-next-line max-len
export default (price, allowZero = false, country = "AU") => {
    const countryLocale = {
        IN: "en-IN",
        AE: "en-AE",
        AU: "en-AU"
    };
    return Number(price || (allowZero ? "0" : "")).toLocaleString(countryLocale[country] || "en-AU");
};
